import { z } from 'zod'

export const facilityFormSchema = z.object({
  name: z.string().min(1).max(255),
  bulstat: z.string().max(13).optional().or(z.literal('')),
  registrationNumber: z.string().max(50).optional().or(z.literal('')),
  address: z.string().min(1).max(500),
  city: z.string().min(1).max(100),
  postalCode: z.string().max(10).optional().or(z.literal('')),
  phone: z.string().min(1).max(20),
  email: z.string().email().optional().or(z.literal('')),
  website: z.string().url().optional().or(z.literal('')),
  bedCount: z.number().int().positive(),
  licenseNumber: z.string().max(100).optional().or(z.literal('')),
  licenseExpiresAt: z.string().optional().or(z.literal('')),
  managerName: z.string().max(200).optional().or(z.literal('')),
  managerPhone: z.string().max(20).optional().or(z.literal('')),
})

export type FacilityFormValues = z.infer<typeof facilityFormSchema>

export const EDITABLE_ROLES = ['OWNER', 'ADMIN'] as const
